import { render, staticRenderFns } from "./BigImage.vue?vue&type=template&id=710c7d80&scoped=true&"
import script from "./BigImage.vue?vue&type=script&lang=js&"
export * from "./BigImage.vue?vue&type=script&lang=js&"
import style0 from "./BigImage.vue?vue&type=style&index=0&id=710c7d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c7d80",
  null
  
)

component.options.__file = "BigImage.vue"
export default component.exports